var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CsText,{staticClass:"block h-fit w-full rounded-lg bg-c-surface-hover p-2 font-mono text-sm",attrs:{"data-component":"CsAiActivityCode","as":"code"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }